<template>
  <div>
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.25 6.75C4.83579 6.75 4.5 7.08579 4.5 7.5C4.5 7.91421 4.83579 8.25 5.25 8.25H9C9.41421 8.25 9.75 7.91421 9.75 7.5C9.75 7.08579 9.41421 6.75 9 6.75H5.25Z"
        fill="white"
      />
      <path
        d="M4.5 10.5C4.5 10.0858 4.83579 9.75 5.25 9.75H7.5C7.91421 9.75 8.25 10.0858 8.25 10.5C8.25 10.9142 7.91421 11.25 7.5 11.25H5.25C4.83579 11.25 4.5 10.9142 4.5 10.5Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.9625 3H12C13.2426 3 14.25 4.00736 14.25 5.25V8.25C14.25 8.66421 13.9142 9 13.5 9C11.8431 9 10.5 10.3431 10.5 12C10.5 13.6569 11.8431 15 13.5 15C13.9142 15 14.25 15.3358 14.25 15.75C14.25 16.1642 13.9142 16.5 13.5 16.5C13.4105 16.5 13.3216 16.4974 13.2334 16.4922C13.198 16.4974 13.1618 16.5 13.125 16.5H4.5C3.25736 16.5 2.25 15.4926 2.25 14.25V5.25C2.25 4.00736 3.25736 3 4.5 3H4.53751C4.71123 2.14416 5.46789 1.5 6.375 1.5H10.125C11.0321 1.5 11.7888 2.14416 11.9625 3ZM4.87486 4.5H4.5C4.08579 4.5 3.75 4.83579 3.75 5.25V14.25C3.75 14.6642 4.08579 15 4.5 15H10.1458C9.43328 14.2039 9 13.1525 9 12C9 9.77025 10.6217 7.91928 12.75 7.56222V5.25C12.75 4.83579 12.4142 4.5 12 4.5H11.6251C11.2831 4.95542 10.7384 5.25 10.125 5.25H6.375C5.76157 5.25 5.21694 4.95542 4.87486 4.5ZM6 3.375C6 3.16789 6.16789 3 6.375 3H10.125C10.3321 3 10.5 3.16789 10.5 3.375C10.5 3.58211 10.3321 3.75 10.125 3.75H6.375C6.16789 3.75 6 3.58211 6 3.375Z"
        fill="white"
      />
      <path
        d="M13.1545 9.95212C13.4571 9.66925 13.9317 9.68524 14.2145 9.98782L15.5479 11.4141C15.8078 11.6921 15.8182 12.1207 15.5722 12.4111L14.2389 13.9848C13.9711 14.3008 13.4979 14.34 13.1818 14.0722C12.8658 13.8045 12.8267 13.3312 13.0944 13.0152L13.3816 12.6763H12C11.5858 12.6763 11.25 12.3405 11.25 11.9263C11.25 11.5121 11.5858 11.1763 12 11.1763H13.2722L13.1188 11.0122C12.8359 10.7096 12.8519 10.235 13.1545 9.95212Z"
        fill="white"
      />
    </svg>
  </div>
</template>

<script>
import { Vue } from "vue-class-component";

export default class SortTransferPickup extends Vue {}
</script>
